import Text17 from './Text17'
export default Text17
